<template>
  <div class="col-five">
    <div class="purchase-list__one-product">
      <div class="purchase-list__one-product-img">
        <img :src="program.photo" alt="" />
      </div>
      <div class="purchase-list__one-product-title">
        {{ sliceProgramNameWord }}
      </div>
      <div class="purchase-list__one-product-price">$ {{ program.price }}</div>
      <button class="transparent-btn" @click="chooseProgram">
        <!-- @click="$bvModal.show(`program-modal${id}`)" -->

        <span class="icon-icon_cart"></span>
        加入購物車
      </button>
    </div>
    <!-- <ProgramModal :id="id" /> -->
  </div>
</template>

<script>
// import ProgramModal from '@/components/Modal/ProgramModal';

export default {
  props: {
    id: {
      type: String,
      required: true
    },
    program: {
      type: Object,
      required: true
    }
  },
  components: {
    // ProgramModal
  },
  computed: {
    sliceProgramNameWord() {
      if (this.program.name.length >= 23) {
        return this.program.name.substring(0, 23) + '...';
      } else {
        return this.program.name;
      }
    }
  },
  data() {
    return {};
  },
  methods: {
    chooseProgram() {
      this.$emit('chooseProgram', this.program);
    }
  }
};
</script>
